import { oc } from "@orpc/contract";
import { z } from "zod";

const attachmentSchema = z.object({
  content: z.string(),
  filename: z.string(),
  type: z.string(),
});

export const trafficGeneratorContracts = {
  sendTrafficEmail: oc
    .input(
      z.object({
        recipientEmail: z.string().email(),
        subject: z.string(),
        textBody: z.string(),
        attachments: z.array(attachmentSchema).optional(),
      }),
    )
    .output(
      z.object({
        success: z.boolean(),
        outboundEmailId: z.string().optional(),
        error: z.string().optional(),
      }),
    )
    .route({ method: "POST" }),

  createScheduledEmail: oc
    .input(
      z.object({
        recipientEmail: z.string().email(),
        subject: z.string(),
        textBody: z.string(),
        attachments: z.array(attachmentSchema).optional(),
        intervalMinutes: z.number().int().positive(),
      }),
    )
    .output(
      z.object({
        success: z.boolean(),
        scheduledEmailId: z.string().optional(),
      }),
    )
    .route({ method: "POST" }),

  listScheduledEmails: oc
    .input(z.object({}))
    .output(
      z.object({
        items: z.array(
          z.object({
            id: z.string(),
            recipientEmail: z.string(),
            subject: z.string(),
            textBody: z.string(),
            intervalMinutes: z.number(),
            status: z.enum(["active", "paused"]),
            sendCount: z.number(),
            lastSentAt: z.string().nullable(),
            nextSendAt: z.string(),
            lastError: z.string().nullable(),
            createdByUserName: z.string(),
            createdAt: z.string(),
          }),
        ),
      }),
    )
    .route({ method: "POST" }),

  updateScheduledEmailStatus: oc
    .input(
      z.object({
        id: z.string(),
        status: z.enum(["active", "paused"]),
      }),
    )
    .output(
      z.object({
        success: z.boolean(),
      }),
    )
    .route({ method: "POST" }),

  deleteScheduledEmail: oc
    .input(
      z.object({
        id: z.string(),
      }),
    )
    .output(
      z.object({
        success: z.boolean(),
      }),
    )
    .route({ method: "POST" }),
};
